import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NHADialogComponent } from './dialog.component';

@NgModule({
	imports: [CommonModule, MatDialogModule, MatIconModule, NHADialogComponent],
	exports: [NHADialogComponent, MatDialogModule],
	providers: [{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, disableClose: true, backdropClass: 'nha-backdrop' } }]
})
export class NHADialogModule {}
